import { HttpParams } from '@angular/common/http';
// import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export const createRequestOption = (req?: any): HttpParams => {
    let options: HttpParams = new HttpParams();
    if (req) {
        Object.keys(req).forEach(key => {
            if (key !== 'sort' && req[key]) {
                options = options.set(key, req[key]);
            }
        });
        if (req.sort) {
            req.sort.forEach((val: any) => {
                if(val)
                options = options.append('sort', val);
            });
        }
    }
    return options;
};

export const createCustomRequestOption = (req?: any): HttpParams => {
  let options: HttpParams = new HttpParams();
  if (req) {
    Object.keys(req).forEach(key => {
      if (key !== 'sort' && req[key] !== null && req[key] !== undefined) {
        options = options.set(key, req[key]);
      }
    });
    if (req.sort) {
      req.sort.forEach((val: any) => {
        if (val !== null && val !== undefined) {
          options = options.append('sort', val);
        }
      });
    }
  }
  return options;
};

export const createCustomRequestPayloadWithNullValuesRemoved = (req: any): any => {
  const request: any = {};

  if (req) {
    Object.keys(req).forEach(key => {
      if (req[key] !== null && req[key] !== undefined) {
        request[key] = req[key];
      }
    });
  }

  return request;
};


export const getFormateDate = function(date: any | null): string { //date: NgbDateStruct
    return date ? `${date.year}-${getNumber(date.month)}-${getNumber(date.day)}` : '';
}

const getNumber = function (input) {
    input = '' + input;
    if (input.length < 2) {
        return '0' + input;
    }
    return input;
}
